import { Pipe, PipeTransform } from '@angular/core';
import { genericFilter } from './utils/generic-filter.utils';


@Pipe({
  name: 'geniricfilter',
})
export class GeniricFilterPipe implements PipeTransform {
  transform(items: any[], searchText: string, exclude: string[] = []): any[] {
    return genericFilter(items, searchText, exclude);
  }
}
